// extracted by mini-css-extract-plugin
export default {"editorContainer":"CodingWindow_editorContainer__N3OfM"};